import { useMutation } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { ICreator } from '@/interfaces';
import routes from '@/lib/routes';

type TDataVariables = Omit<ICreator, 'createdAt' | 'updatedAt' | '_id'>;
type TResponseData = string;

export const useRequestCreateCreator = () => {

  const { invalidate } = useInvalidateQueries();
  const { isPending, error, mutateAsync } = useMutation({
    mutationKey: [routes.api.referrals, 'create'],
    mutationFn: (data: TDataVariables) =>
      apiClient
        .post<TResponseData>(routes.api.referrals, data)
        .then(handleApiResponse),
    onSuccess: () => invalidate(routes.api.referrals)
  });

  const trigger = (data: TDataVariables) =>
    mutateAsync(data);

  return ({
    isLoading: isPending,
    trigger,
    error
  });

};  
